module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.27.0-de48ae84e.svg#instagram-flat","viewBox":"0 0 512.001 512.001"}